import React, { Component } from "react";
import { Clear } from "@material-ui/icons";

export const ErrorCheck = () => {
  return (
    <div style={{ width: "80px",
      height: "80px",
      margin:" 0 auto"}}>
      <button className="btn btn-rounded-circle btn-outline-danger" style={{borderRadius:"50%", width: "80px", height: "80px"}}>
        <Clear fontSize="large"/>
      </button>
    </div>
  );
};
